@if (step == steps.Loading) {
  <panel>
    <h1><skeleton /></h1>
    <skeletons [defaultSkeletons]="5" />
    <skeleton />
  </panel>
}

@if (step == steps.SelectPlans) {
  <panel>
    <h1>{{ 'settlement.deselect-product-plans' | translate }}</h1>
    <company-products-list [sortColumns]="false" [onlyActivePlans]="true" [multiSelect]="isSelectable" [productPlans]="productPlans" [(selectedProductPlans)]="selectedProductPlans" />
    <section>
      <button confirm [loader]="false" [ignoreValidation]="true" (click)="useSelectedProductPlans()">{{ 'settlement.button.create-new' | translate }}</button>
    </section>
  </panel>
}

@if (step == steps.ConfirmSelection) {
  <panel>
    <h1>{{ 'settlement.confirm-selection.header' | translate }}</h1>
    <section>{{ 'settlement.confirm-selection.description' | translate }}</section>
    <section>
      <div>{{ 'settlement.confirm-selection.plans-not-in-settlement' | translate }}</div>
      <ng-container *ngTemplateOutlet="productPlanListTemplate; context:{ $implicit: remainingActiveProductPlans }" />
    </section>
    <section>
      <div>{{ 'settlement.confirm-selection.plans-in-settlement' | translate }}</div>
      <ng-container *ngTemplateOutlet="productPlanListTemplate; context:{ $implicit: selectedActiveProductPlans }" />
    </section>
    <section>
      <button confirm [loader]="false" (click)="useSelectedProductPlans(false)" [ignoreValidation]="true">{{ 'settlement.button.create-new-confirm' | translate }}</button>
      <button ghost [loader]="false" (click)="reset();" [ignoreValidation]="true">{{ 'settlement.button.undo-selected-plans' | translate }}</button>
    </section>
  </panel>
}

@if (step == steps.Reason) {
  <panel>
    <h1>{{ 'settlement.select-reason' | translate }}</h1>
    <section>
      <reason-select [type]="reasonType.Settlement" (valueChange)="setReason($event)" [label]="'settlement.reason-label' | translate" />
    </section>
    <section>
      <button confirm [ignoreValidation]="true" [active]="settlement.reason != undefined" (click)="step = steps.Comment" [label]="'settlement.button.confirm-reason' | translate"></button>
    </section>
  </panel>
}

@if (step == steps.Comment) {
  <panel>
    <h1>{{ 'settlement.comment-panel-header' | translate }}</h1>
    <section>
      <custom-input [inputType]="inputType.Textarea" [(value)]="settlement.comment" [required]="false" textAlign="left" [label]="'settlement.comment' | translate" />
    </section>
    <section>
      <button confirm [ignoreValidation]="true" [active]="settlement.comment != ''" (click)="goToNextPlan()" [label]="'settlement.button.confirm-comment' | translate"></button>
      <button ghost [ignoreValidation]="true" (click)="skipComment()" [label]="'settlement.button.skip-comment' | translate"></button>
    </section>
  </panel>
}

@if (step == steps.StepThroughPlans) {
  <panel>
    <h1>{{ 'settlement.view-each-product-plan' | translate }}</h1>
    <settlement-product-plans #settlementProductPlans [settlement]="settlement" [plansAmount]="plansAmount" [showIncludeVat]="false" [activeSettlementProductPlan]="activeSettlementProductPlan" [clickable]="false" />
  </panel>
}

@if (step == steps.StepThroughPlans && activeSettlementProductPlan) {
  <panel>
    <h1>{{ 'settlement.settlement-for-plan' | translate: { planName: activeSettlementProductPlan.productPlan | productName } }}</h1>
    <h2>{{ 'settlement.estimated-settlement' | translate }}</h2>
    <h3>{{ 'settlement.estimate-description' | translate }}</h3>
    <section>
      <custom-input [inputType]="inputType.Currency" [(value)]="activeSettlementProductPlan.amount" [required]="true" textAlign="right" [label]="'settlement.amount' | translate" />
      <date-input [(value)]="activeSettlementProductPlan.endDate" [label]="'settlement.end-date' | translate" [placeholder]="'settlement.end-date-placeholder' | translate" />
    </section>
    <section>
      <button confirm #nextPlanButton [label]="'settlement.button.next-plan' | translate" (click)="goToNextPlan()"></button>
    </section>
  </panel>
}

@if (step == steps.ChooseInstallments) {
  <panel>
    <h1>{{ 'settlement.should-settlement-consist-of-installments' | translate }}</h1>
    <section>
      <button confirm [ignoreValidation]="true" (click)="step = steps.SetInstallments">{{ 'general.true' | translate }}</button>
      <button confirm [ignoreValidation]="true" (click)="step = steps.SetDueDate">{{ 'general.false' | translate }}</button>
    </section>
  </panel>
}

@if (step == steps.SetInstallments) {
  <panel>
    <h1>{{ 'settlement.set-installments' | translate }}</h1>
    <section>
      <custom-input [inputType]="inputType.Number" [(value)]="settlement.installments" [required]="true" [label]="'settlement.installments' | translate" />
    </section>
    <section>
      <button confirm [label]="'settlement.button.confirm-installments' | translate" (click)="step = steps.SetDueDate"></button>
    </section>
  </panel>
}

@if (step == steps.SetDueDate) {
  <panel>
    <h1>{{ (settlement.installments == 1 ? 'settlement.set-due-date' : 'settlement.set-due-date-for-first-installment') | translate }}</h1>
    <section>
      <date-input [(value)]="settlement.dueDate" [required]="true" [label]="'settlement.due-date' | translate" [placeholder]="'settlement.due-date-placeholder' | translate" />
    </section>
    <section>
      <button confirm [label]="'settlement.button.confirm-due-date' | translate" (click)="goToConfirm();"></button>
    </section>
  </panel>
}

@if (step == steps.ConfirmSettlement) {
  <panel>
    <h1>{{ 'settlement.confirm-settlement' | translate }}</h1>
    <settlement [settlement]="settlement" [plansAmount]="plansAmount" />
    <section>
      <button confirm [ignoreValidation]="true" (click)="saveSettlement();" [label]="'settlement.button.save-settlement' | translate"></button>
      <button ghost [ignoreValidation]="true" (click)="reset();" [label]="'settlement.button.cancel-and-reset' | translate"></button>
    </section>
  </panel>
}

<ng-template #productPlanListTemplate let-productPlanList>
  <ul>
    @for (productPlan of productPlanList; track productPlan) {
      <li>
        {{ productPlan | productName }}
      </li>
      @if (productPlan.inverseParent.length > 0) {
        <ng-container *ngTemplateOutlet="productPlanListTemplate; context:{ $implicit: productPlan.inverseParent }" />
      }
    }
  </ul>
</ng-template>
